'use client'

import { useState } from 'react'
import { splitEmailQuote } from './emailQuote'
import { messageImageHtml } from './inlineImages'

export function SupportMessageBody({
  html,
  filePath,
  orderId,
  browserContext,
  className = '',
}: {
  html: string
  filePath: string
  orderId?: number
  browserContext?: string
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)
  const [open, setOpen] = useState(false)
  const { visible, quoted } = splitEmailQuote(html)
  const bodyClass = `${className} [&_img]:my-3 [&_img]:h-auto [&_img]:max-h-96 [&_img]:max-w-full [&_img]:rounded [&_img]:object-contain`
  return (
    <>
      <div
        key={attempt}
        className={bodyClass}
        onErrorCapture={event => {
          if (event.target instanceof HTMLImageElement) setFailed(true)
        }}
        dangerouslySetInnerHTML={{
          __html: messageImageHtml(visible, filePath, orderId, browserContext),
        }}
      />
      {quoted && (
        <div className="mt-3">
          <button
            type="button"
            className="cursor-pointer text-xs text-gray-500 underline"
            aria-expanded={open}
            onClick={() => setOpen(value => !value)}
          >
            {open ? 'Hide quoted text' : 'Show quoted text'}
          </button>
          {open && (
            <div
              className={`${bodyClass} mt-2 border-l-2 border-gray-200 pl-3 text-gray-500`}
              dangerouslySetInnerHTML={{
                __html: messageImageHtml(
                  quoted,
                  filePath,
                  orderId,
                  browserContext
                ),
              }}
            />
          )}
        </div>
      )}
      {failed && (
        <p role="status" className="mt-2 text-xs text-gray-500">
          An image is awaiting a safety scan or is unavailable.{' '}
          <button
            type="button"
            className="underline"
            onClick={() => {
              setFailed(false)
              setAttempt(value => value + 1)
            }}
          >
            Reload images
          </button>
        </p>
      )}
    </>
  )
}
